module.exports = __webpack_public_path__ + "assets/4e72fef2072826e1d0644efd8bb96f63.woff2";